import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const pubAmountByAdminAction = createAsyncThunk(
    'pub-amount-by-admin',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/manage/balance/publisher`,{
               
                    appId: data?.app_id,
                    amount: data?.amount,
                    isCredit: data?.isCredit ,
                    publisherId: data?.publisherId
                
            }) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const pubAmountByAdminSlice = createSlice({
    name: 'pub-amount-by-admin',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(pubAmountByAdminAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(pubAmountByAdminAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(pubAmountByAdminAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const pubAmountByAdminReducer = pubAmountByAdminSlice.reducer